var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerrace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15V21.5C16 21.7761 15.7761 22 15.5 22C15.2239 22 15 21.7761 15 21.5V15H10C9.44772 15 8.98825 14.5453 9.12839 14.011C9.12935 14.0074 9.13032 14.0037 9.1313 14C9.38433 13.0466 9.99591 12.1628 10.9038 11.4645C12.1228 10.5268 13.7761 10 15.5 10C17.2239 10 18.8772 10.5268 20.0962 11.4645C21.0041 12.1628 21.6157 13.0466 21.8687 14C21.8697 14.0037 21.8706 14.0074 21.8716 14.011C22.0118 14.5453 21.5523 15 21 15L16 15ZM10.1786 14C10.4049 13.3735 10.8475 12.7694 11.5135 12.2571C12.1645 11.7564 12.9808 11.3839 13.8831 11.1793C13.6331 11.4347 13.3909 11.71 13.1698 11.9905C12.8529 12.3927 12.5668 12.8213 12.3577 13.2384C12.2342 13.4847 12.1294 13.743 12.0657 14H10.1786ZM15.5 11.0931C15.0262 11.4262 14.4472 11.9851 13.9552 12.6095C13.6679 12.974 13.4227 13.3454 13.2517 13.6866C13.1954 13.7989 13.1493 13.9035 13.1127 14L17.8873 14C17.8507 13.9035 17.8046 13.7989 17.7483 13.6866C17.5773 13.3454 17.3321 12.974 17.0448 12.6095C16.5528 11.9851 15.9738 11.4262 15.5 11.0931ZM18.9343 14L20.8214 14C20.5951 13.3735 20.1525 12.7694 19.4865 12.2571C18.8355 11.7564 18.0192 11.3839 17.1169 11.1793C17.3669 11.4347 17.6091 11.71 17.8302 11.9905C18.1471 12.3927 18.4332 12.8213 18.6423 13.2384C18.7658 13.4847 18.8706 13.743 18.9343 14Z",
    fill: "#00112B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.5C18 18.2239 18.2239 18 18.5 18C18.7761 18 19 18.2239 19 18.5V20H22C22.5523 20 23 20.4477 23 21V22H18V18.5Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerrace);
export default __webpack_public_path__ + "static/media/terrace.6ee9bf7d141a32034150fb512fe798a7.svg";
export { ForwardRef as ReactComponent };